import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';
import {
  Role,
  CreateRolePayload,
  UpdateRolePayload,
} from '@shared/models/entities/roles.model';

@Injectable({ providedIn: 'root' })
export class RolesService extends ApiBaseService<Role> {

  constructor() {
    super('roles');
  }

  /**
   * Crea un rol nuevo.
   */
  async createRole(payload: CreateRolePayload): Promise<Role | null> {
    const body: CreateRolePayload = {
      operationType: 'single',
      tools: [],
      ...payload,
      name: payload.name.trim(),
    };
    const response = await this.create(body as unknown as Role);
    return Array.isArray(response.data) && response.data.length > 0
      ? response.data[0]
      : null;
  }

  /**
   * Actualiza un rol. Solo viajan los campos incluidos en `payload`.
   */
  async updateRole(payload: UpdateRolePayload): Promise<Role | null> {
    if (!payload.id) {
      throw new Error('updateRole requiere id.');
    }
    const body: UpdateRolePayload = {
      operationType: 'single',
      ...payload,
      ...(payload.name ? { name: payload.name.trim() } : {}),
    };
    const response = await this.update(body as unknown as Role);
    return Array.isArray(response.data) && response.data.length > 0
      ? response.data[0]
      : null;
  }

  /**
   * Soft-delete: marca deleted=true.
   */
  async softDeleteRole(id: string): Promise<Role | null> {
    return this.updateRole({ id, deleted: true });
  }

  /**
   * Compatibilidad con el código de Medtronic: devolvía `{data: []}`.
   * Ahora consulta de verdad la tabla de roles.
   */
  async getAllRols(): Promise<{ data: any[] }> {
    try {
      await this.search({ searchType: 'default', condition: { deleted: false } });
      return { data: this.listData() as any[] };
    } catch {
      return { data: [] };
    }
  }
}
